export default __webpack_public_path__ + "static/media/banner.0852cb8e.png";